module.exports = {
      id: "cookie-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.b9c19baa.svg#cookie-usage",
      toString: function () {
        return this.url;
      }
    }